import { DisneyComponentData } from "./MediaPlayerComponent";
import { useTheme } from '@mui/material/styles';
import React from 'react';
import DisneyComponent from './DisneyComponent';
import { useNavigate } from 'react-router-dom';
import { color } from "@mui/system";
import { Views } from "features/enumerations";
import TitleService from "title-service";
import { useContainerSize } from "./RedQuickLoLoList";
import RedQuickLoLoList from './RedQuickLoLoList';
import { get_all_approvedMedia } from "features/approvedMedia/approvedMedia-slice";
import { useSelector } from "react-redux";

export default function NextMedias(props: { data: DisneyComponentData[] }) {
    const theme = useTheme();
    const approvedMedia_list = useSelector(get_all_approvedMedia)
    const navigate = useNavigate();
    const componentRef: React.Ref<HTMLDivElement> = React.useRef(null);
    const componentRef_size = useContainerSize(componentRef);
    let data = (props.data || []).map((t) => {
        return ({
            color: 'transparent', component: <DisneyComponent
                panelStyle={{
                    ['--hover-color']: theme?.palette?.dark[900] || '#ffffff'
                }}
                onPlaying={(args) => {
                }}
                onViewing={() => {
                }}
                videoUrl={t.video}
                title={t.title}
                imageSrc={t.imageSrc}
                altText={t.altText}
                onPlay={() => {
                    if (t?.id) {
                        let ami = approvedMedia_list.find(x => x.mediaId === t?.id);
                        if (ami) {
                            navigate(`/${Views.Watch}/inde/${ami?.mediaId}/${ami?.id}`, {
                                replace: true
                            })
                        }
                    }
                }} />
        })
    });
    return (
        <div ref={componentRef} style={{
            position: 'absolute',
            left: `-97vw`,
            bottom: 130,
            maxWidth: '100vw'
        }}>
            <RedQuickLoLoList
                lists={[data]}
                sections={[TitleService('Next...')]}
                itemsPerSlide={Math.min(Math.max(Math.floor(componentRef_size.width / 1500 * 5), 1), 6)}
                itemContainerCls="lolo__panel__container" />
        </div>
    )
}